import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@phosphor-icons/react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFB]">
        <Spinner size={32} className="animate-spin text-emerald-600" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
